import { useState, useEffect, useCallback } from 'react';
import { instance } from '@/config/axios';
import { urls } from '@/config/urls';
import { Vehicles } from '@/config/types/Vehicles';

const { server } = urls;

export function useAllVehicles() {
  const [data, setData] = useState<Vehicles[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      let all: Vehicles[] = [];
      let page = 1;
      let hasNext = true;

      while (hasNext) {
        const resp = await instance.get<{ count: number; total_pages: number; next: string | null; previous: string | null; results: Vehicles[] }>(
          server.vehicle,
          { params: { page, page_size: 100 } }
        );
        all = all.concat(resp.data.results);
        hasNext = !!resp.data.next;
        page += 1;
      }
      
      setData(all);
    } catch (err: any) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  return { data, loading, error, refetch: fetchAll };
}